<template>
  <div id="app">
    <div class="block b--flex b--justify ovh">
      <ui-navigation />

      <transition name="view-fade" mode="out-in">
        <router-view/>
      </transition>
      <ui-sidebar />
      <ui-modal />
    </div>
  </div>
</template>

<script>
// Modules
import UiNavigation from '@/components/ui/Navigation'
import UiModal from '@/components/ui/Modal'
import UiSidebar from '@/components/ui/Sidebar'

export default {
  // Components
  components: {
    UiNavigation,
    UiSidebar,
    UiModal
  }
}
</script>

<style lang="scss">
@import "assets/scss/styles.scss";
</style>
